import { animated } from '@react-spring/web'
import { useCallback, useContext, useMemo } from 'react'

import { FrameBuilderStringsContext } from '@frame-builder/contexts/strings-context'
import { FrameBuilderValidationContext } from '@frame-builder/contexts/validation-context'
import { useBlinkingState } from '@frame-builder/lib/preview-animation'
import { type StepDefinitionProps } from '@frame-builder/lib/steps'

import Link from '@components/link'
import Button from '@frame-builder/components/utility/button'
import ListContainer from '@frame-builder/components/utility/list-container'
import ConfigurationDefinition from '../configuration-definition'
import ProfileList from './profile-list'

const FrameStyleDefinition = ({
  stepNumber,
  onClose,
  className,
}: StepDefinitionProps) => {
  const { validationErrorMessages } = useContext(FrameBuilderValidationContext)
  const frameBuilderStrings = useContext(FrameBuilderStringsContext)

  const [opacity, setIsBlinking] = useBlinkingState()

  const isValidSelection = useMemo(() => {
    return (
      !validationErrorMessages?.frameStyleProfilePreview &&
      !validationErrorMessages?.frameStyleTexturePreview
    )
  }, [validationErrorMessages])

  const handleOkClick = useCallback(() => {
    if (isValidSelection) {
      onClose()
    }

    if (!isValidSelection) {
      setIsBlinking(true)
    }
  }, [isValidSelection, onClose, setIsBlinking])

  return (
    <ConfigurationDefinition
      stepNumber={stepNumber}
      title={frameBuilderStrings.frameStyleStepTitle}
      footerContent={frameBuilderStrings.frameStyleStepFooter}
      onClose={onClose}
      className={className}
    >
      <div className="flex flex-col px-5 space-y-5">
        <animated.div
          style={{
            opacity,
          }}
        >
          <ListContainer gapSize="sm">
            <ProfileList />
          </ListContainer>

          {!!frameBuilderStrings.frameStyleProfileReadMore &&
            !!frameBuilderStrings.frameStyleProfileReadMoreUrl && (
              <Link
                link={{
                  url: frameBuilderStrings.frameStyleProfileReadMoreUrl,
                }}
                className="block text-xs"
              >
                {frameBuilderStrings.frameStyleProfileReadMore}
              </Link>
            )}
        </animated.div>

        <div>
          <Button
            size="small"
            isVisuallyDisabled={!isValidSelection}
            onClick={handleOkClick}
            className="min-w-32 grow-0 shrink-0"
          >
            {frameBuilderStrings.controlOkLabel}
          </Button>
        </div>
      </div>
    </ConfigurationDefinition>
  )
}

export default FrameStyleDefinition
